var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormFieldSet',{attrs:{"headline":_vm.headlineAdditionalInfo}},[_c('FormFieldTextArea',{attrs:{"label":_vm.$t('Notizen'),"text":_vm.text,"variant":"horizontal","rows":"4"},on:{"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }